import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchOrgPublicPageStateArgs,
  PublicPageOwnerArgs,
} from '../api/publicPage.api';

import { fetchOrganizationSalesContact } from '../api/organizations.api';
import {
  fetchContactChannels,
  fetchOrgPublicPageState,
  fetchPublicPage,
  fetchPublicPageCurrencySuggestion,
  fetchPublicPageLocations,
  fetchServiceOfferings,
  fetchSocialLinks,
} from '../api/publicPage.api';

export const publicPageQueryKeys = createQueryKeys('publicPage', {
  fetchChannels: ({ organizationId, ownerType }: PublicPageOwnerArgs) => ({
    queryFn: () => fetchContactChannels({ organizationId, ownerType }),
    queryKey: [organizationId, ownerType],
  }),
  fetchCurrencySuggestion: ({
    organizationId,
    ownerType,
  }: PublicPageOwnerArgs) => ({
    queryFn: () =>
      fetchPublicPageCurrencySuggestion({ organizationId, ownerType }),
    queryKey: [organizationId, ownerType],
  }),
  fetchLocations: ({ organizationId, ownerType }: PublicPageOwnerArgs) => ({
    queryFn: () => fetchPublicPageLocations({ organizationId, ownerType }),
    queryKey: [organizationId, ownerType],
  }),
  fetchOfferings: ({ organizationId, ownerType }: PublicPageOwnerArgs) => ({
    queryFn: () => fetchServiceOfferings({ organizationId, ownerType }),
    queryKey: [organizationId, ownerType],
  }),
  fetchPage: ({ organizationId, ownerType }: PublicPageOwnerArgs) => ({
    queryFn: () => fetchPublicPage({ organizationId, ownerType }),
    queryKey: [organizationId, ownerType],
  }),
  // The org's Business details sales contact — kept under `publicPage` so
  // every public-page invalidation refreshes it with the rest of the section.
  fetchSalesContact: ({ organizationId }: { organizationId: string }) => ({
    queryFn: () => fetchOrganizationSalesContact({ organizationId }),
    queryKey: [organizationId],
  }),
  fetchSocialLinks: ({ organizationId, ownerType }: PublicPageOwnerArgs) => ({
    queryFn: () => fetchSocialLinks({ organizationId, ownerType }),
    queryKey: [organizationId, ownerType],
  }),
  fetchState: ({ organizationId }: FetchOrgPublicPageStateArgs) => ({
    queryFn: () => fetchOrgPublicPageState({ organizationId }),
    queryKey: [organizationId],
  }),
});
